let mutations = {
  userDetails (state, data) {
    if (data.pan) {
      state.userDetails.pan = data.pan
      state.disablePanField = true
    }
    state.appliedToDmi = data.dmi ? data.dmi.appliedToDmi : false
  },
  pinCode (state, data) {
    if (data.personal) {
      state.invalidPersonalPinCode = data.status
      state.userDetails.address['city'] = data.response.city
      state.userDetails.address['postcode'] = data.response.pinCode
      state.userDetails.address['state'] = data.response.state
    } else {
      state.invalidEmploymentPinCode = data.status
      state.userDetails.employmentDetail.address['city'] = data.response.city
      state.userDetails.employmentDetail.address['postcode'] =
        data.response.pinCode
      state.userDetails.employmentDetail.address['state'] = data.response.state
    }
  },
  dmiStart (state, data) {
    return (state.userDetails = data)
  },
  invalidPinCode (state, data) {
    if (data.personal) {
      state.invalidPersonalPinCode = data.status
      state.userDetails.address['city'] = undefined
      state.userDetails.address['state'] = undefined
    } else {
      state.invalidEmploymentPinCode = data.status
      state.userDetails.employmentDetail.address['city'] = undefined
      state.userDetails.employmentDetail.address['state'] = undefined
    }
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/dmi/mutations.js